const MIN_SCORE = 1;

export default MIN_SCORE;
